import React, { lazy, Suspense } from 'react'
import getMovieTitle from '../functions/getMovieTitle';
import SliderBasicTitle from '../SliderBasic/SliderBasicTitle';


const Highlight = lazy(() => import('./Highlight'));


const HighlightLoading = ({
    title,
    hasTrailer
}) => {
    return (
        <div>
            <div className="image-wrapper ">
                <div className="image background-visuals-container"></div>

                <div className='gradient-highlight'>
                    {hasTrailer && <div className="trailer-large trailer-wrapper-button trailer"></div>}

                    <div className="slider-basic-item-content">
                        <div className="inner-content-wrapper">
                            <h2 className={'headline title-xlarge-black'}>{title}</h2>
                            <div className="information"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const HighlightLoadingArthouse_2 = ({
    title,
    hasTrailer
}) => (
    <div className="image-wrapper">
        <div className='image-section'>
            <div className="image background-visuals-container"></div>

            {hasTrailer &&  <div className="trailer-small"/>}
        </div>

        <div className='gradient'>
            <div className="slider-basic-item-content">
                <div className='slide-item-content-wrapper'>
                    <div className='top-section'>
                        <SliderBasicTitle title={title}/>
                    </div>

                    <div className='bottom-section'></div>
                </div>
            </div>
        </div>
    </div>
)

const HighlightLoadingArthouse = ({
    title
}) => (
    <div className='arthouse-highlight'>
        <div className="image-wrapper">
            <div className="image background-visuals-container"></div>

            <div className='gradient-highlight'>
                <div className="slider-basic-item-content">
                    <div className="inner-content-wrapper">
                        <div className='top-content'>
                            <h2 className="headline title-xxlarge" style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: title}}></h2>
                        </div>

                        <div className='bottom-content'></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
)



const HighlightLazy = (props) => {
    const currentHighlight = props.highlights[props.items[0].id]

    if(!currentHighlight) {
        return ''
    }

    const { movieRefID } = currentHighlight

    if(!props.moviesData[movieRefID]) {
        return ''
    }

    const movieData = props.moviesData[movieRefID]
    const currentTitle  = getMovieTitle(movieData)
    let ItemLoading 

    if(props.theme === 'Arthouse') {
        ItemLoading = props.highlightAppearance === 'arthouse_2' ? HighlightLoadingArthouse_2 : HighlightLoadingArthouse
    } else {
        ItemLoading = HighlightLoading
    }

    return (
        <Suspense fallback={<ItemLoading title={currentTitle} hasTrailer={movieData.trailerURL}/>}>
            <Highlight
                currentHighlight={currentHighlight}
                movieData={movieData}
                currentTitle={currentTitle}
                {...props}
            />
        </Suspense>        
    )
}

export default HighlightLazy